module.exports = __webpack_public_path__ + "img/credit-spreadsheet.45952b1c.png";